import React, { useContext, useEffect } from 'react';
import { MFBeaconButton, MFBeaconModal } from '../Beacon/BeaconComponents';
import { FlowContext } from '../../core/flow-engine';
import { withDefault } from '../../core/util';
import { getAccountTypeDisplayName } from '../../screens/WelcomeScreen/utils';
import { accountTypes } from '../../flows/shared/utils';
import { handleAccountAccessRouting, handleBuyFlowRouting } from './utils';
import { isNonTransferIndividualOrTOD } from '../../screens/PersonalInformationScreen/util';
import { dispatchOverlayLoad } from '../../analytics/analytics-helper';
import styles from './style.css';

const ExistingAgreementsBlockModal = () => {
  const { appState } = useContext(FlowContext);
  const accountType = withDefault(appState.store.accountType);
  const chargeType = withDefault(appState.store.chargeType);
  const subAccountType = withDefault(appState.store.app?.iraAccountType);
  const profileApplicationID = withDefault(
    appState.store.app?.profileApplicationID,
    ''
  );
  const accountTypeDisplay = isNonTransferIndividualOrTOD(accountType)
    ? 'individual general investing account'
    : getAccountTypeDisplayName(accountType, subAccountType);

  /* MODAL CONTENT */
  const articleForText = accountType === accountTypes.INDIVIDUAL ? 'an' : 'a';
  const modalTitle = `You already have ${articleForText} ${accountTypeDisplay}.`;
  const viewDashboardText = `To manage your T. Rowe Price accounts, select View Dashboard.`;
  const addNewPositionsText = `To add new positions to your existing ${accountTypeDisplay}, select Add New Mutual Fund(s).`;
  const nonTransferIndividualOrTODText =
    'T. Rowe Price policy limits clients to a single individual general investing account, which includes Transfer on Death accounts.';

  useEffect(() => {
    // Send analytics the modal overlay state
    dispatchOverlayLoad('Account Already exists');
  }, []);

  const isRollover = () => accountType === accountTypes.ROLLOVER;
  const renderRolloverHelpText = () => (
    <div>
      <p className="bold-content">Need Help?</p>
      <span>
        <p>
          Get help from a T. Rowe Price RolloverConcierge™, available weekdays 8
          a.m. - 8 p.m. ET.
        </p>
        <a href="tel:1-866-294-5526" className="rollover-concierge-number">
          1-866-294-5526
        </a>
      </span>
      <style jsx="true">{styles}</style>
    </div>
  );

  return (
    <MFBeaconModal open removeCloseButton data-metrics-location="PU">
      <div className="beacon-modal__title">{modalTitle}</div>
      <div className="beacon-modal__description">
        {isNonTransferIndividualOrTOD(accountType, chargeType) && (
          <p>{nonTransferIndividualOrTODText}</p>
        )}
        {isRollover() ? renderRolloverHelpText() : <p>{viewDashboardText}</p>}
        <p>{addNewPositionsText}</p>
      </div>

      <div className="modal-btn-container">
        <MFBeaconButton
          role="button"
          type="button"
          id="existingAgreeAddMFsBtn"
          data-name="existingAgreeAddMFsBtn"
          variant="secondary"
          onClick={() => handleBuyFlowRouting(profileApplicationID)}
          label="Add New Mutual Fund(s)"
        />
        <MFBeaconButton
          role="button"
          id="existingAgreeBlockModalAcctAccessBtn"
          data-name="existingAgreeBlockModalAcctAccessBtn"
          variant="primary"
          onClick={() => handleAccountAccessRouting(profileApplicationID)}
          label="View Dashboard"
        />
      </div>
      <style jsx="true">{styles}</style>
    </MFBeaconModal>
  );
};

export default ExistingAgreementsBlockModal;
